import { polyfill } from "es6-promise";
polyfill();

import Vue from "vue";
import Vuex from "vuex";

const state = {
  page_state: 0, //possible values: 0, 1, 2, 21 (21 is mobile)
  popup_state: "",
  popup_video_src: "",
  can_skip_videos: true,
  popup_img_src: "",
  unity_progress: 0,
  unity_info: "",
  form_status: 0,
  contact_form_status: 0,

  ambience_volume: 0.17,
  ambience_max_volume: 0.17,
  ambience_current_vol: 0,
  ambience_previous_vol: -1,
  voice_volume: 1,

  instructions_shown: false,

  sections: [
    {
      name: "Products",
      id: "1",
      display_in_bar: true,
      display_in_footer: false,
      popup_type: "pdf_list",
      has_voiceover: true,
      voiceover_has_played: false
    }
  ],

  sections_content: {
    event_info: {
      tag: "allergan-aaopt"
    },
    "0": {
      name: "Home",
      subids: {
        left: {
          type: "image",
          src: "Microsite_Event_Ad.jpg",
          link: "https://www.durystahcp.com/",
          style: {
            "max-height": "90vh!important",
            "max-width": "820px",
            width: "100%"
          }
        },
        middle: {
          type: "video_list",
          title: "Home Videos",
          list: [
            {
              filename: "0_Allergan",
              title: "0_Allergan.jpg",
              thumb: "0_Allergan.jpg",
              has_mp4: true,
              has_webm: true,
              // type: "internal_video"

              url: "https://player.vimeo.com/video/486628237",
              type: "internal_vimeo",
              height_ratio: 360 / 640
            },
            {
              filename: "1_Eye Care Professional Focus",
              title: "1_Eye Care Professional Focus",
              thumb: "1_Eye-Care-Professional-Focus.jpg",
              has_mp4: true,
              has_webm: true,
              type: "internal_video"
            },
            {
              filename: "2_Access and Affordability",
              title: "2_Access and Affordability",
              thumb: "2_Access-and-Affordability.jpg",
              has_mp4: true,
              has_webm: true,
              type: "internal_video"
            },
            {
              filename: "3_Scientific Advancement",
              title: "3_Scientific Advancement",
              thumb: "3_Scientific-Advancement.jpg",
              has_mp4: true,
              has_webm: true,
              type: "internal_video"
            }
          ]
        }
      }
    },
    "1": {
      name: "Products",
      subids: {
        "1-Alphagan": {
          type: "product_list",
          title: "Alphagan",
          list: [
            {
              title: "Glaucoma Therapeutics Savings Program",
              filename: "https://www.savewithAYS.com",
              thumb: "1_weblink_sm.jpg",
              type: "external_link"
            },
            {
              title: "2_MillennialEYE",
              thumb: "2_MillennialEYE_thumb.jpg",
              filename_prefix: "2_MillennialEYE_",
              count: 1,
              filetype: "jpg",
              slide_ratio: 1024 / 768,
              type: "internal_slideshow"
            }
          ]
        },
        "2-Lumigan": {
          type: "product_list",
          title: "Lumigan",
          list: [
            {
              title: "1_Glaucoma_EOY_Savings",
              thumb: "1_Glaucoma_EOY_Savings.jpg",
              filename_prefix: "1_Glaucoma_EOY_Savings_",
              count: 12,
              filetype: "jpg",
              slide_ratio: 1080 / 810,
              type: "internal_slideshow"
            },
            {
              title: "Glaucoma Therapeutics Savings Program ",
              filename: "https://www.savewithAYS.com",
              thumb: "2_weblink_sm.jpg",
              type: "external_link"
            },
            {
              title: "3_MillennialEYE",
              thumb: "3_MillennialEYE_thumb.jpg",
              filename_prefix: "3_MillennialEYE_",
              count: 1,
              filetype: "jpg",
              slide_ratio: 1024 / 768,
              type: "internal_slideshow"
            }
          ]
        },
        "3-Durysta": {
          type: "product_list",
          title: "Durysta",
          list: [
            {
              title: "2_11317140_ALG_DUR_Patient_Brochure_Digital_D6_CF",
              thumb: "2_11317140_ALG_DUR_Patient_Brochure_Digital_D6_CF.jpg",
              filename_prefix:
                "2_11317140_ALG_DUR_Patient_Brochure_Digital_D6_CF_",
              count: 6,
              filetype: "jpg",
              slide_ratio: 791 / 1024,
              type: "internal_slideshow",
              link: [
                {
                  href: "https://media.allergan.com/products/durysta_pi.pdf",
                  extra_class: "link_0"
                },
                {
                  href: "https://media.allergan.com/products/durysta_pi.pdf",
                  extra_class: "link_1"
                },
                {
                  href: "https://media.allergan.com/products/durysta_pi.pdf",
                  extra_class: "link_2"
                },
                {
                  href: "https://media.allergan.com/products/durysta_pi.pdf",
                  extra_class: "link_3"
                },
                {
                  href: "https://media.allergan.com/products/durysta_pi.pdf",
                  extra_class: "link_4"
                },
                {
                  href: "https://media.allergan.com/products/durysta_pi.pdf",
                  extra_class: "link_5"
                }
              ]
            },

            {
              title: "3_11417138_Convention_Banner",
              filename: "3_11417138_Convention_Banner.jpg",
              thumb: "3_11417138_Convention_Banner_thumb.jpg",
              type: "internal_image",
              link: "https://www.durystahcp.com/"
            },
            {
              title: "6_DUR131455-v2_DURYSTA-Branded-Journal-Ad",
              thumb: "6_DUR131455-v2_DURYSTA-Branded-Journal-Ad.jpg",
              filename_prefix: "6_DUR131455-v2_DURYSTA-Branded-Journal-Ad_",
              count: 7,
              filetype: "jpg",
              slide_ratio: 857 / 1280,
              type: "internal_slideshow"
            }
          ]
        },

        "4-Restasis": {
          type: "product_list",
          title: "Restasis",
          list: [
            {
              title: "RES121493-v2",
              thumb: "RES121493-v2-thumb.jpg",
              filename_prefix: "RES121493-v2_",
              count: 17,
              filetype: "jpg",
              slide_ratio: 878 / 1024,
              type: "internal_slideshow"
            }
          ]
        },
        "5-Combigan": {
          type: "product_list",
          title: "Combigan",
          list: [
            {
              title: "Glaucoma Therapeutics Savings Program",
              filename: "https://www.savewithAYS.com",
              thumb: "1_weblink_sm.jpg",
              type: "external_link"
            },
            {
              title: "2_MillennialEYE",
              thumb: "2_MillennialEYE_thumb.jpg",
              filename_prefix: "2_MillennialEYE_",
              count: 1,
              filetype: "jpg",
              slide_ratio: 1024 / 768,
              type: "internal_slideshow"
            }
          ]
        },
        "6-Xen": {
          type: "product_list",
          title: "Xen",
          list: [
            {
              title: "2_190165_XEN_SalesAid_PGS_FNL",
              thumb: "2_190165_XEN_SalesAid_PGS_FNL.jpg",
              filename_prefix: "2_190165_XEN_SalesAid_PGS_FNL_",
              count: 17,
              filetype: "jpg",
              slide_ratio: 1325 / 1024,
              type: "internal_slideshow"
            }
          ]
        },
        "7-Ozurdex": {
          type: "product_list",
          title: "Ozurdex",
          list: [
            {
              title:
                "1_005683_Ozurdex_Healios_Web_Banners-042720300x250_banner",
              thumb: "1_005683_Ozurdex_Healios_Web_Banners-thumb.jpg",
              filename_prefix:
                "1_005683_Ozurdex_Healios_Web_Banners-042720300x250_banner_",
              count: 16,
              filetype: "jpg",
              slide_ratio: 854 / 1024,
              type: "internal_slideshow",
              link: [
                {
                  href: "https://www.ozurdexprecisionprogram.com/Supplements",
                  extra_class: "link_full_image"
                }
              ]
            },
            {
              title:
                "Injection Pathway and Mechanism of Action in Diabetic Macular Edema",
              url: "https://player.vimeo.com/video/474748104",
              thumb: "2_vimeolink.jpg",
              type: "internal_vimeo",
              height_ratio: 929.25 / 1652
            },
            {
              title: "3_OZURDEX-PI",
              thumb: "3_OZURDEX-PI.jpg",
              filename_prefix: "3_OZURDEX-PI_",
              count: 15,
              filetype: "jpg",
              slide_ratio: 1024 / 791,
              type: "internal_slideshow"
            },
            {
              title: "4_UNB138006-EyeCue-Overview-Flashcard",
              thumb: "4_UNB138006-EyeCue-Overview-Flashcard_FINAL.jpg",
              filename_prefix: "4_UNB138006-EyeCue-Overview-Flashcard_FINAL_",
              count: 2,
              filetype: "jpg",
              slide_ratio: 1325 / 1024,
              type: "internal_slideshow"
            },
            {
              title: "5_009504-OZX-Savings-Program-SlimJim_ST",
              thumb: "5_009504-OZX-Savings-Program-SlimJim_ST.jpg",
              filename_prefix:
                "5_009504-OZX-Savings-Program-SlimJim_ST_",
              count: 3,
              filetype: "jpg",
              slide_ratio: 1024 / 1024,
              type: "internal_slideshow"
            },
            {
              title: "6_OZU138498_005158-Patient-Slim-Jim_NOANNOS",
              thumb: "6_OZU138498_005158-Patient-Slim-Jim_NOANNOS-Final.jpg",
              filename_prefix:
                "6_OZU138498_005158-Patient-Slim-Jim_NOANNOS-Final_",
              count: 26,
              filetype: "jpg",
              slide_ratio: 1024 / 1024,
              type: "internal_slideshow"
            }
          ]
        },
        "8-Refresh": {
          type: "product_list",
          title: "Refresh",
          list: [
            {
              title: "1_REF111192-v5-Sample-Closet-Hang-Chart_9_11_20",
              filename: "1_REF111192-v5-Sample-Closet-Hang-Chart_9_11_20.jpg",
              thumb:
                "1_REF111192-v5-Sample-Closet-Hang-Chart_9_11_20_thumb.jpg",
              type: "internal_image"
            },
            {
              title: "3_REF139996_REF_DIGITAL_LeaveBehind_v2_9_11_20",
              thumb: "3_REF139996_REF_DIGITAL_LeaveBehind_v2_9_11_20.jpg",
              filename_prefix:
                "3_REF139996_REF_DIGITAL_LeaveBehind_v2_9_11_20_",
              count: 2,
              filetype: "jpg",
              slide_ratio: 1325 / 1024,
              type: "internal_slideshow"
            },
            {
              title: "4_REF111197-v10_REFDirect_TakeOne",
              thumb: "4_REF111197-v10_REFDirect_TakeOne.jpg",
              filename_prefix: "4_REF111197-v10_REFDirect_TakeOne_",
              count: 2,
              filetype: "jpg",
              slide_ratio: 1275 / 825,
              type: "internal_slideshow"
            }
          ]
        }
      }
    },

    header: {
      subids: {
        middle: {
          type: "video"
        },
        medicalinfo: {
          type: "external_link",
          title:
            "https://www.allergan.com/healthcare-providers/medical-information-request",
          text:
            "You are now leaving the Allergan promotional site and going to",
          href:
            "https://www.allergan.com/healthcare-providers/medical-information-request"
        }
      }
    },
    footer: {
      subids: {
        support: {
          type: "support",
          title: "Eye Care Customer Support"
        },
        contact: {
          type: "form"
        }
      }
    },
    instructions: {
      is_vimeo: true,
      show_initial_image: true,
      src: "https://player.vimeo.com/video/486628237",
      // is_vimeo: false,
      // src: "0/middle/pdf/0_Allergan",
      has_webm: false,
      has_mp4: false,
      // height_ratio: 1080 / 1920
      height_ratio: 360 / 640
    }
  },

  footer_additional_links: [],

  current_section: "",
  current_sub_section: "",

  current_secondary_section: "",
  current_secondary_sub_section: "",

  app_state: -1,
  initial_movement_mode: "AUTO",
  app_type: "mobile",

  booth_form: {
    name: "",
    lastname: "",
    email: "",
    country: "",
    specialty: ""
  },

  browser: null,
  browser_is_mobile: false,

  //general site options, be careful with this
  site_config: {
    use_intro_image: false,
    use_intro_video: false,
    use_intro_form: false,
    use_footer_as_links: false,
    validate_form: true,
    fake_mobile: false
  },
  parentRatio: 0,
  app_width: "100%"
};

const mutations = {
  SET_PAGE_STATE(state, val) {
    state.page_state = val;
  },
  SET_POPUP_STATE(state, val) {
    console.log("set_popup_state", val);
    state.popup_state = val;
  },
  SET_UNITY_PROGRESS(state, val) {
    state.unity_progress = val;
  },
  SET_UNITY_INFO(state, val) {
    state.unity_info = val;
  },
  SET_FORM_STATUS(state, val) {
    state.form_status = val;
  },
  SET_CONTACT_FORM_STATUS(state, val) {
    state.contact_form_status = val;
  },
  SET_VIDEO_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "video";
  },
  SET_IMAGE_POPUP(state, val) {
    state.popup_img_src = val;
    state.popup_state = "image";
  },
  SET_SLIDESHOW_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "slideshow";

    console.log(state);
  },
  SET_LINKS_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "links";
  },
  SET_CONTACT_POPUP(state, val) {
    state.popup_video_src = val;
    state.popup_state = "form";
  },
  SET_ACTIVE_SECTION(state, val) {
    console.log("setting active section to ", val);
    state.current_section = val + "";
    state.current_secondary_section = "";
  },
  SET_ACTIVE_SUB_SECTION(state, val) {
    console.log("setting active subsection to ", val);
    state.current_sub_section = val + "";
    state.current_secondary_sub_section = "";
  },
  SET_SECONDARY_SECTION(state, val) {
    state.current_secondary_section = val.section;
    state.current_secondary_sub_section = val.sub_section;
  },
  SET_APP_STATE(state, val) {
    state.app_state = val;
  },

  SET_SIMPLE_VAL(state, obj) {
    state[obj.name] = obj.val;
  },
  SAVE_BOOTH_FORM(state, obj) {
    state.booth_form = JSON.parse(JSON.stringify(obj));
    state.form_status = 1;
  },

  SAVE_INITIAL_MOVEMENT_FORM(state, app_mode) {
    state.initial_movement_mode = app_mode;
    console.log("initial app mode", state.initial_movement_mode);
  },

  SET_BROWSER_IDENTITY(state, browser) {
    state.browser = browser;
  },

  SET_VOICEOVER_PLAYED(state, section) {
    state.sections.forEach((item, idx) => {
      //other voiceover might be playing so let's stop them
      if (item.has_voiceover && item.id == section + "") {
        item.voiceover_has_played = true;
      }
    });
  }
};

const actions = {
  set_page_state({ commit }, val) {
    commit("SET_PAGE_STATE", val);
  },
  set_popup_state({ commit }, val) {
    commit("SET_POPUP_STATE", val);
  },
  set_video_popup({ commit }, val) {
    commit("SET_VIDEO_POPUP", val);
  },

  set_image_popup({ commit }, val) {
    commit("SET_IMAGE_POPUP", val);
  },
  set_slideshow_popup({ commit }, val) {
    commit("SET_SLIDESHOW_POPUP", val);
  },
  set_links_popup({ commit }, val) {
    commit("SET_LINKS_POPUP", val);
  },
  set_contact_popup({ commit }, val) {
    commit("SET_CONTACT_POPUP", val);
  },
  set_unity_progress({ commit }, val) {
    commit("SET_UNITY_PROGRESS", val);
  },
  set_unity_info({ commit }, val) {
    commit("SET_UNITY_INFO", val);
  },
  set_current_section({ commit }, val) {
    commit("SET_ACTIVE_SECTION", val);
  },
  set_current_subsection({ commit }, val) {
    commit("SET_ACTIVE_SUB_SECTION", val);
  },
  //should have val.section and val.sub_section
  set_secondary_section({ commit }, val) {
    commit("SET_SECONDARY_SECTION", val);
  },
  set_app_state({ commit }, val) {
    commit("SET_APP_STATE", val);
  },
  set_simple_val({ commit }, obj) {
    commit("SET_SIMPLE_VAL", obj);
  },
  set_browser_identity({ commit }, obj) {
    commit("SET_BROWSER_IDENTITY", obj);
  },
  set_voiceover_played({ commit }, obj) {
    commit("SET_VOICEOVER_PLAYED", obj);
  },
  submit_form({ commit }, data) {
    if ("undefined" != typeof data.skip_form && data.skip_form == true) {
      commit("SAVE_INITIAL_MOVEMENT_FORM", data.app_mode);
      commit("SET_FORM_STATUS", 1);
      setTimeout(
        function () {
          commit("SET_FORM_STATUS", 2);
          commit("SET_PAGE_STATE", 2);
        }.bind(this),
        2000
      );
      return;
    }

    const axios = require("axios");

    commit("SET_FORM_STATUS", 1);
    commit("SAVE_BOOTH_FORM", data);
    commit("SAVE_INITIAL_MOVEMENT_FORM", data.app_mode);
    let axiosConfig = {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Access-Control-Allow-Origin": "*"
    };

    axios({
      method: "post",
      url: "/form.php",
      headers: {
        "Content-Type": "application/json"
      },
      data: data
    })
      .then(function (response) {
        commit("SET_FORM_STATUS", 2);
        commit("SET_PAGE_STATE", 2);
      })
      .catch(function (error) {
        console.log(error);
        commit("SET_FORM_STATUS", 2);
        commit("SET_PAGE_STATE", 2);
      });
  },
  set_contact_form_status({ commit }, data) {
    commit("SET_CONTACT_FORM_STATUS", data);
  },

  submit_photo_data({ commit }, data) {
    const axios = require("axios");
    const config = {
      headers: { "content-type": "multipart/form-data" }
    };
    console.log(data);
    return new Promise((resolve, reject) => {
      axios
        .post("/", data, config)
        .then((response) => {
          console.log(response.data);
          resolve();
        })
        .catch((error) => reject());
    });
  },

  submit_contact_form({ commit }, data) {
    const axios = require("axios");

    commit("SET_CONTACT_FORM_STATUS", 1);
    // setTimeout(() => {
    //   commit("SET_CONTACT_FORM_STATUS", 2);
    // }, 4000);

    axios({
      method: "post",
      url:
        "https://allergan.protoexpo.com/contactform/process-contact-form.php",
      headers: {
        "Content-Type": "application/json"
      },
      data: data
    })
      .then(function (response) {
        commit("SET_CONTACT_FORM_STATUS", 2);
      })
      .catch(function (error) {
        console.log(error);
        commit("SET_CONTACT_FORM_STATUS", 3);
      });
  },

  set_app_width({ commit }, app_width) {
    console.log("set app width to", app_width);
    commit("SET_SIMPLE_VAL", {
      name: "app_width",
      val: app_width
    });
  }
};

const getters = {
  appBarSections: (state) => {
    return state.sections.filter((section) => section.display_in_bar);
  },
  footerBarSections: (state) => {
    return state.sections.filter((section) => section.display_in_footer);
  },
  getSection: (state) => {
    return (section_id) => {
      let section = null;
      state.sections.forEach((item) => {
        if (item.id == section_id) {
          section = item;
        }
      });
      return section;
    };
  },
  sectionContent: (state) => {
    return (section_id) => {
      return state.sections_content[section_id];
    };
  },
  sectionCount: (state) => {
    return state.sections.length;
  },
  eventTag: (state) => {
    return state.sections_content.event_info.tag;
  }
};

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  strict: process.env.NODE_ENV !== "production"
});



// WEBPACK FOOTER //
// ./src/store/index.js